import comp from "./DescriptorTableV2";
export default comp;
